import AppIcon from '../icons/AppIcon'
import styles from './Keypad.module.css'

interface KeypadProps {
  onPress: (key: string) => void
  onBackspace: () => void
}

export function QuickAmountChips({
  values,
  onSelect,
}: {
  values: number[]
  onSelect: (value: number) => void
}) {
  return (
    <div className={styles.chips} data-testid="quick-amounts">
      {values.map((v) => (
        <button key={v} type="button" className={styles.chip} onClick={() => onSelect(v)}>
          {v}
        </button>
      ))}
    </div>
  )
}

export default function Keypad({ onPress, onBackspace }: KeypadProps) {
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', 'back']

  return (
    <div className={styles.grid} data-testid="keypad">
      {keys.map((key) =>
        key === 'back' ? (
          <button
            key={key}
            type="button"
            className={[styles.key, styles.fn].join(' ')}
            onClick={onBackspace}
            aria-label="Backspace"
          >
            <AppIcon icon="mdi:backspace-outline" size={24} />
          </button>
        ) : (
          <button
            key={key}
            type="button"
            className={[styles.key, key === '.' && styles.fn].filter(Boolean).join(' ')}
            onClick={() => onPress(key)}
          >
            {key}
          </button>
        ),
      )}
    </div>
  )
}
